import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/announcements', config);
}
const store = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/announcements', data);
}
const update = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/announcements/' + id, formData);
}
const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/announcements/' + id);
}
const del = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/announcements/' + id);
}
const getAllAnnouncement = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/announcements/me');
}
const getFileUrl = (uuid) => {
    const baseURL = process.env.VUE_APP_ENDPOINT_STUDENT || '';
    return `${baseURL}/announcements/file/${uuid}`;
}
const getDownloadUrl = (uuid) => {
    const baseURL = process.env.VUE_APP_ENDPOINT_STUDENT || '';
    return `${baseURL}/announcements/download/${uuid}`;
}
const downloadFile = async (uuid) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/announcements/download/${uuid}`, { responseType: 'blob' });
}

export default {
    getAll,
    store,
    update,
    get,
    del,
    getAllAnnouncement,
    getFileUrl,
    getDownloadUrl,
    downloadFile
}
